export default __webpack_public_path__ + "static/media/close.5bbc1472.svg";